import type {
  BatchSendLandingWaitlistInvitesReply,
  BatchSendLandingWaitlistInvitesRequest,
  CheckLandingWaitlistReply,
  CheckLandingWaitlistRequest,
  ListLandingWaitlistAdminReply,
  ListLandingWaitlistAdminRequest,
  SendLandingWaitlistInviteReply,
  SendLandingWaitlistInviteRequest,
  SubmitLandingWaitlistReply,
  SubmitLandingWaitlistRequest,
} from '@/types';
import api from './api';

function getBrandHeaders(brandId: string) {
  return {
    headers: {
      brand_id: brandId,
    },
  };
}

export const landingWaitlistApi = {
  submit: async (
    brandId: string,
    data: SubmitLandingWaitlistRequest,
  ): Promise<SubmitLandingWaitlistReply> => {
    return api.post(
      '/api/v1/landing-waitlist/submit',
      data,
      getBrandHeaders(brandId),
    );
  },

  check: async (
    brandId: string,
    data: CheckLandingWaitlistRequest,
  ): Promise<CheckLandingWaitlistReply> => {
    return api.post(
      '/api/v1/landing-waitlist/check',
      data,
      getBrandHeaders(brandId),
    );
  },

  listAdmin: async (
    brandId: string,
    data: ListLandingWaitlistAdminRequest,
  ): Promise<ListLandingWaitlistAdminReply> => {
    return api.post(
      '/api/v1/landing-waitlist/admin/list',
      data,
      getBrandHeaders(brandId),
    );
  },

  sendInvite: async (
    brandId: string,
    data: SendLandingWaitlistInviteRequest,
  ): Promise<SendLandingWaitlistInviteReply> => {
    return api.post(
      '/api/v1/landing-waitlist/admin/send-invite',
      data,
      getBrandHeaders(brandId),
    );
  },

  batchSendInvites: async (
    brandId: string,
    data: BatchSendLandingWaitlistInvitesRequest,
  ): Promise<BatchSendLandingWaitlistInvitesReply> => {
    return api.post(
      '/api/v1/landing-waitlist/admin/batch-send-invites',
      data,
      getBrandHeaders(brandId),
    );
  },
};
